import Axios from 'axios'
import Moment from 'moment'
import { isTraceabilityEnabled } from '@/utils/feature-toggle'

const traceabilitySearchService = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.TRACEABILITY_BASE_URL
    return AxiosInstance
  },
  axiosForBackend() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.API_URL
    return AxiosInstance
  },
  getTraceabilityOrderByPatientName(patientName) {
    return isTraceabilityEnabled()
      ? this.axios().put('/exams/filters', { patientName: patientName })
      : Promise.resolve({ data: [] })
  },
  getTraceabilityOrderBySampleID(id) {
    return isTraceabilityEnabled()
      ? this.axios().put('/exams/filters', { sampleId: id })
      : Promise.resolve({ data: [] })
  },
  getTraceabilityOrderByOSLis(id) {
    return isTraceabilityEnabled()
      ? this.axios().put('/exams/filters', { idOsLis: id })
      : Promise.resolve({ data: [] })
  },
  getTraceabilityOrderByBatch(id) {
    return isTraceabilityEnabled()
      ? this.axios().put('/exams/filters', { idLot: id })
      : Promise.resolve({ data: [] })
  },
  getTraceabilityOrderByOrderId(orderId) {
    return isTraceabilityEnabled()
      ? this.axios().get('/exams/orders/' + orderId)
      : Promise.resolve({ data: {} })
  },
  getTraceabilityOrderByDate(startDate, endDate) {
    return isTraceabilityEnabled()
      ? this.axios().get('/exams/search', {
          params: {
            startDate: Moment(startDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            endDate: Moment(endDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          },
        })
      : Promise.resolve({ data: [] })
  },
  getTraceabilityByStatusExam(status, placeExecution) {
    if (!isTraceabilityEnabled()) return Promise.resolve({ data: [] })

    const nto = placeExecution ? `&nto=${placeExecution}` : ''

    if (status === 'ATRASADO') return this.axios().get('/exams/delay')
    return this.axios().get(
      `/exams/status?status=${status === 'EM_TRANSITO' ? 'EM_TRANSITO_ENTRE_NTO, EM_TRANSITO' : status}${nto}`
    )
  },
  getCurrentBatchCoordinates(batchBarcode) {
    return this.axiosForBackend().get(
      '/traceability/exam-order-coordinates/' + batchBarcode
    )
  },
  getPlaceExecutionCoordinates(placeExecutionId) {
    return this.axiosForBackend().get('/placeExecution/' + placeExecutionId)
  },
  getGroupedExams(
    params = { filterType: '', filterValue: '', status: '', limit: 20, nextCursor: '' }
  ) {
    return this.axios().get('/exams/grouped', { params })
  },
  getGroupedExamsCount(params = { filterType: '', filterValue: '', status: '' }) {
    return this.axios().get('/exams/grouped/count', { params })
  },
}

export default traceabilitySearchService
